import * as server from '../entries/pages/match/_id_/_homeoraway_/passes/_page.server.js';

export const index = 7;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/match/_id_/_homeoraway_/passes/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/match/[id]/[homeoraway]/passes/+page.server.js";
export const imports = ["_app/immutable/nodes/7.J2_5CIOa.js","_app/immutable/chunks/scheduler.XyTI1WgU.js","_app/immutable/chunks/index.HYtw-Ape.js","_app/immutable/chunks/transform.jx0PEwp_.js","_app/immutable/chunks/ribbon.OUnpp3PX.js","_app/immutable/chunks/DownloadButton.g7TS8ZMi.js"];
export const stylesheets = ["_app/immutable/assets/7.8gMzPQ4B.css","_app/immutable/assets/DownloadButton.kiusxNa0.css"];
export const fonts = [];
